import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
const TermOfService = () => {
  return (
    <Box my={5}>
      <Typography variant='h4'>Privacy Policy</Typography>
      <Box my={2}>
        <Typography variant='h5'>Welcome to MizBan!</Typography>
        <Typography variant='body2' align='justifyContent'>
          Mizban builds technologies and services that enable people to connect
          with whom they care and want to spend quality time with, build
          stronger communities, and grow together. These Terms govern your use
          of Mizban and Makans, and the other products, features, apps,
          services, technologies, and software we offer (the Mizban Products),
          except where we expressly state that separate terms (and not these)
          apply. These Products are provided to you by Mizban. Mizban products
          and services covered by these Terms are free of charge. Mizban is not
          developed to show us ads and sell products and services. Instead, by
          using our Products, you agree that MizBan might compromise your
          interests which are not critical to keep friends together. We use the
          data collected from any Miz to help increasing the involvement of the
          participants. We don’t sell your personal data to advertisers, and we
          don’t share information that directly identifies you (such as your
          name, email address or other contact information) with advertisers.
          Instead, MizBan can tell you things like the kind of actions you can
          do benefit you and other members of the Miz. We provide Miz members
          with reports about the performance of their activities that help them
          understand how other Miz members are interacting with their actions.
          These actions and their results should be obvious to all the
          participants of the Miz. Our Data Policy explains how we collect and
          use your personal data to determine some of the ads you see and
          provide all of the other services described below. You can also go to
          your MizBan Settings at any time to review the privacy choices you
          have about how we use your data. Data Policy This policy describes the
          information we process to support MizBan, any Miz, and other products
          and features offered by MizBan (Mizban Products). You can find
          additional tools and information in the MizBan Settings.
        </Typography>
      </Box>
      <Button
        variant='contained'
        size='small'
        color='secondary'
        component={Link}
        to='/'
      >
        Back to Main
      </Button>
    </Box>
  );
};

export default TermOfService;
